import homeView from './index'
import searchView from './search'
import dateView from './date'

const routes = {
  path: 'tour2',
  name: 'Private/Tour2',
  component: homeView,
  redirect: { name: 'Private/Tour2/Search' },
  children: [
    {
      path: 'search',
      name: 'Private/Tour2/Search',
      component: searchView
    },
    {
      path: 'date/:tour/:date',
      name: 'Private/Tour2/Date',
      component: dateView
    }
  ]
}

export default routes
